import { CalculationInfoLegalFinland } from '~/app/compositions/content/calculation-info/core/calculation-info-legal-fi';
import { PartialCarConfiguration } from '~/app/market-config/models/car-confi-market-configuration';
import { PartialUiConfiguration } from '~/app/market-config/models/car-confi-ui-configuration';

export const local: PartialCarConfiguration = {
	hasJetStream: true,
	enableFinancingServices: false,
	hideMonthlyRates: true,
	showCaESummaryText: true,
	engineCardKeyfacts: ['acceleration', 'maxPowerHp', 'chargingTime'],
	uiPreferences: {
		prices: {
			totalPriceFrom: 'total',
			hiddenPriceParts: ['model', 'nettoOptions', 'total', 'importCharge', 'destinationCharge'],
			vatConfig: {
				feature: 'inclusive',
				trimlineAndEngine: 'inclusive',
				totalPrice: 'inclusive',
				priceParts: {},
			},
		},
	},
	enablePriceDisclaimer: true,
	useStaticPriceDateRemark: true,
	nextBestActions: [
		{
			icon: '',
			description: 'Ota yhteyttä jälleenmyyjään',
			labelText: 'Ota yhteyttä jälleenmyyjään',
			target: '_blank',
			trackingName: 'contact',
			url: 'https://www.audi.fi/fi/web/fi/yhteystiedot/yhteydenotto.html',
		},
		{
			icon: 'test-drive',
			description: 'Sovi koeajo',
			labelText: 'Sovi koeajo',
			target: '_blank',

			trackingName: 'testdrive',
			url: 'https://www.audi.fi/fi/web/fi/yhteystiedot/varaa-koeajo.html',
		},
	],
	summaryFooterCta: {
		icon: 'send',
		description: 'Pyydä tarjous',
		labelText: 'Pyydä tarjous',
		target: '_blank',

		trackingName: 'contact',
		url: 'https://www.audi.fi/fi/web/fi/yhteystiedot/pyyda-tarjous.html',
	},
};

export const local_ui: PartialUiConfiguration = {
	calculationInfoComponent: <CalculationInfoLegalFinland className="calculation" />,
};
